export default __webpack_public_path__ + "static/media/SEA_7359.c141db6b.jpg";